var BgimageJS = {};

( function( $ ){

	var mobiledataBG = $( '.js-background-image' ).data( 'mobilebackground' );
	var desktopBG = $( '.js-background-image' ).css( 'background-image' );

	BgimageJS.switchBG = function(){
		if ( Viewport.documentWidth().width < 767 ) {
			$( '.js-background-image' ).css({ 'background-image': 'url(' + mobiledataBG + ')' });
		} else {
			$( '.js-background-image' ).css({ 'background-image': desktopBG });
		}
	};

	BgimageJS.getMinHeight = function() {
		if ( Viewport.documentWidth().width < 991 ) {
			var $gridGutterHalf = 17;
			if ( Viewport.documentWidth().width < 481 ) {
				$gridGutterHalf = 20;
			}

			if( /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) ) {
				$gridGutterHalf = 0;
			}

			
			var containerWidth = $('.js-business-image .container').width() - $gridGutterHalf;
			var subtractor = ( Viewport.documentWidth().width - containerWidth ) / 2;

			$('.js-business-image').removeAttr('style');
			$('.js-business-image  .image').removeAttr('style');

			$('.js-business-image .image').width( Viewport.documentWidth().width - subtractor);

		} else {
			var getImageHeight = $('.business-image').height();
	
			$('.js-business-image').removeAttr('style');
			$('.js-business-image  .image').removeAttr('style');
			$('.js-business-image').css('min-height', getImageHeight);
		}
	};


	$( window ).on( 'resize', function(){
		BgimageJS.switchBG();
		BgimageJS.getMinHeight();
	});

	$( document ).ready( function(){
		BgimageJS.switchBG();
		BgimageJS.getMinHeight();
	});

})( jQuery );
